import React from "react";
import { useTranslation } from "react-i18next";

import { NotificationDescriptionProps } from "./types";

import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";

import "./styles.css";

export const NotificationDescription = ({
  filename,
  descriptionKey,
  className,
}: NotificationDescriptionProps) => {
  const { t } = useTranslation();

  return (
    <div className={`notification-container body-s-regular ${className}`}>
      <div>{t(descriptionKey)}</div>
      <div className="notification-container-filename-container">
        <BaseSpinner size="extra-small" />
        <span className="notification-container-filename">{filename}</span>
      </div>
    </div>
  );
};
